var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRegMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 257.259,
    height: 149.122,
    viewBox: "0 0 257.259 149.122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b,.m{fill:#e5e5e5;}.b{opacity:0.392;}.c{fill:#9c3;}.d{fill:#79a520;}.e{fill:#396;}.f{fill:#218352;}.g{fill:#dce5fe;}.h{fill:#f0f0f0;}.i{fill:#ccc;}.j{fill:#939393;}.k{mix-blend-mode:soft-light;isolation:isolate;}.l{clip-path:url(#a);}.n{fill:#9c99bc;}.o{fill:#d7d6e2;}.p{fill:#66f;}.q{fill:#24286d;}.r{fill:url(#b);}.s{fill:url(#c);}.t{fill:url(#d);}.u{fill:url(#e);}.v{fill:#f93;}.w{fill:url(#f);}.x{fill:url(#g);}.y{fill:url(#h);}.z{fill:url(#i);}.aa{fill:url(#j);}.ab{fill:#150e42;}.ac{fill:url(#k);}.ad{fill:url(#l);}.ae{fill:url(#m);}.af{fill:url(#n);}.ag{fill:url(#o);}.ah{fill:url(#p);}.ai{fill:url(#q);}.aj{fill:url(#r);}.ak{fill:#f9b776;}.al{fill:#dda064;}.am{fill:url(#s);}.an{fill:url(#t);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M684.021,341.049l63.566,38.37,59.94-36.1V287.422H689.012Z",
    transform: "translate(-684.021 -287.422)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 3.644,
    y1: -12.945,
    x2: -0.055,
    y2: 11.133,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09005d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0f91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: -52.639,
    y1: -0.843,
    x2: -53.146,
    y2: 2.39,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb3b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -10.094,
    y1: -5.387,
    x2: -12.61,
    y2: 17.678,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: -45.55,
    y1: -0.224,
    x2: -46.065,
    y2: 2.539,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 0.541,
    y1: -0.073,
    x2: 0.484,
    y2: 1.325,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: -73.424,
    y1: -0.15,
    x2: -75.177,
    y2: 2.993,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: -258.041,
    y1: -10.491,
    x2: -258.7,
    y2: -10.138,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 0.424,
    y1: 0.008,
    x2: 0.6,
    y2: 1.002,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 2.503,
    y1: 0.132,
    x2: -0.052,
    y2: 0.564,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: -488.263,
    y1: -225.831,
    x2: -485.144,
    y2: -228.206,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 18.773,
    y1: -0.484,
    x2: 15.938,
    y2: 6.012,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 70.81,
    y1: 0.5,
    x2: 71.81,
    y2: 0.5,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 21.585,
    y1: 0.946,
    x2: 22.253,
    y2: 0.099,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 47.218,
    y1: -2.223,
    x2: 40.2,
    y2: 5.384,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 82.012,
    y1: 0.5,
    x2: 83.012,
    y2: 0.5,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 15.133,
    y1: 0.917,
    x2: 15.603,
    y2: 0.085,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 6.313,
    y1: 2.511,
    x2: 5.441,
    y2: 3.915,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 15.631,
    y1: 5.741,
    x2: 13.442,
    y2: 9.325,
    xlinkHref: "#r"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: -254.728,
    y1: -5.837,
    x2: -255.387,
    y2: -5.483,
    xlinkHref: "#b"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-135 -209)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M118.854,237.851c2.985,5.281,7.727,9.722,11.382,14.66,10.56,14.268-.427,30.964,4.392,46.345,4.2,13.4,21.664,16.994,34.43,17.538,21.512.917,43-.457,63.739-6.291,14.392-4.049,28.8-9.349,43.972-9.67,15.507-.328,30.094,5.9,45.076,8.842,16.451,3.233,36.126-.278,40.092-18.648,2.457-11.381-4.157-21.862-4.777-33.067-.819-14.834,13.969-22.975,15.882-36.843,1.206-8.744-3.3-16.556-9.183-22.882-6.206-6.675-14.551-12.572-24.125-13.12-10.008-.573-18.94,4.682-28.293,7.191-26.286,7.049-41.206-16.462-65.4-19.742-10.909-1.479-24.316-.777-34.222,4.3-9.211,4.722-13.68,15.213-24.012,18.293-10.935,3.26-20.941-3.256-31.332-5.338a27.7,27.7,0,0,0-27.657,10.056c-6.526,8.131-13.588,18.841-12.778,29.577A20.843,20.843,0,0,0,118.854,237.851Z",
    transform: "translate(19.019 37.521)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(159.983 253.912)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.902)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M492.541,659.847c-6.413,1.282-14.6-5.709-17.24-13.347-2.715-7.86,2.263-11.153,2.225-22.059-.044-12.39-6.489-14.257-10.752-30.957-.962-3.768-6.528-25.573.371-29.66,6.378-3.779,24.3,7.066,27.435,20.947,2.239,9.9-4.683,14.054-2.039,25.582,2.32,10.115,8.416,10.261,10.752,20.02C506.136,642.253,500.961,658.164,492.541,659.847Z",
    transform: "translate(-463.742 -563.064)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M613.583,828.368c1.729-13.349-1.644-33.943-4.777-48.869-3.392-16.16-7.243-29.341-7.281-29.472l-.534.157c.039.131,3.884,13.295,7.271,29.434,3.124,14.883,6.487,35.409,4.769,48.68Z",
    transform: "translate(-585.25 -728.583)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 28.254)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M370.125,876.451c8.412-4.383,11.291-19.433,6.509-24.324-3.231-3.305-7.864.171-12.334-3.255-5.707-4.374-1.509-12.612-6-23.3-3.818-9.092-12.977-17.7-18.329-15.931-5.6,1.848-8.553,15.559-3.769,23.811,3.111,5.366,7.874,5.63,8.908,10.621,1.2,5.791-4.594,8.432-4.625,14.046C340.434,868.208,359,882.25,370.125,876.451Z",
    transform: "translate(-333.809 -809.413)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M496.415,1036.193a.343.343,0,0,0,.308-.492c-11.151-22.979-14.422-49.637-14.453-49.9a.343.343,0,0,0-.68.081c.032.268,3.316,27.04,14.517,50.121A.343.343,0,0,0,496.415,1036.193Z",
    transform: "translate(-464.638 -965.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M361.193,858.345a.164.164,0,0,0,.129-.264c-3.52-4.518-7.421-11.306-6.017-17.986a11.707,11.707,0,0,1,3.214-6.074.164.164,0,1,0-.214-.247,11.834,11.834,0,0,0-3.32,6.254c-.789,3.755-.375,9.97,6.079,18.255A.164.164,0,0,0,361.193,858.345Z",
    transform: "translate(-352.295 -830.944)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M655.8,1202.191a.163.163,0,0,0,.135-.071c5.409-7.895,7.254-13.995,5.483-18.131a7.931,7.931,0,0,0-5.591-4.368.164.164,0,0,0-.053.323,7.59,7.59,0,0,1,5.345,4.178c1.721,4.026-.113,10.019-5.453,17.813a.163.163,0,0,0,.135.256Z",
    transform: "translate(-618.725 -1137.159)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(313.417 253.912)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M1683.135,659.847c6.413,1.282,14.6-5.709,17.24-13.347,2.715-7.86-2.263-11.153-2.224-22.059.044-12.39,6.489-14.257,10.751-30.957.962-3.768,6.528-25.573-.371-29.66-6.379-3.779-24.3,7.066-27.435,20.947-2.239,9.9,4.683,14.054,2.039,25.582-2.32,10.115-8.416,10.261-10.752,20.02C1669.54,642.253,1674.716,658.164,1683.135,659.847Z",
    transform: "translate(-1671.599 -563.064)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1772.625,828.368c-1.729-13.349,1.644-33.943,4.777-48.869,3.392-16.16,7.243-29.341,7.281-29.472l.534.157c-.038.131-3.884,13.295-7.271,29.434-3.124,14.883-6.487,35.409-4.769,48.68Z",
    transform: "translate(-1760.622 -728.583)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.105 28.254)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1768.522,876.451c-8.412-4.383-11.291-19.433-6.509-24.324,3.231-3.305,7.864.171,12.333-3.255,5.707-4.374,1.509-12.612,6-23.3,3.818-9.092,12.977-17.7,18.329-15.931,5.6,1.848,8.553,15.559,3.769,23.811-3.112,5.366-7.874,5.63-8.907,10.621-1.2,5.791,4.593,8.432,4.625,14.046C1798.213,868.208,1779.65,882.25,1768.522,876.451Z",
    transform: "translate(-1759.705 -809.413)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1873.514,1036.193a.343.343,0,0,1-.308-.492c11.151-22.979,14.422-49.637,14.453-49.9a.343.343,0,0,1,.68.081c-.032.268-3.316,27.04-14.517,50.121A.342.342,0,0,1,1873.514,1036.193Z",
    transform: "translate(-1860.158 -965.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M2074.375,858.345a.164.164,0,0,1-.129-.264c3.52-4.518,7.421-11.306,6.017-17.986a11.706,11.706,0,0,0-3.214-6.074.164.164,0,1,1,.214-.247,11.831,11.831,0,0,1,3.32,6.254c.79,3.755.376,9.97-6.079,18.255A.164.164,0,0,1,2074.375,858.345Z",
    transform: "translate(-2038.14 -830.944)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M1781.573,1202.191a.164.164,0,0,1-.135-.071c-5.409-7.895-7.254-13.995-5.483-18.131a7.931,7.931,0,0,1,5.591-4.368.164.164,0,0,1,.053.323,7.59,7.59,0,0,0-5.345,4.178c-1.721,4.026.113,10.019,5.453,17.813a.164.164,0,0,1-.135.256Z",
    transform: "translate(-1773.515 -1137.159)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.259 232.008)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M633.914,724.719v70.355c0,5.177,4.548,9.374,10.157,9.374H762.21c5.609,0,10.157-4.2,10.157-9.374V724.719H633.914Z",
    transform: "translate(-633.77 -684.275)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M736.715,391.587l-30.029-18.17a8.841,8.841,0,0,0-9.312,0l-30.029,18.165L632.66,412.563l34.685,20.929,34.685,20.929,34.685-20.952L771.4,412.563Z",
    transform: "translate(-632.66 -372.091)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "k",
    transform: "translate(2.614 67.975)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M655.69,1013.926a.243.243,0,0,1-.182-.4l43.26-48.672a.243.243,0,0,1,.363.323l-43.26,48.672A.242.242,0,0,1,655.69,1013.926Z",
    transform: "translate(-655.447 -964.768)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(89.767 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1481.633,1013.926a.242.242,0,0,1-.182-.082l-43.26-48.672a.243.243,0,0,1,.363-.323l43.26,48.672a.243.243,0,0,1-.182.4Z",
    transform: "translate(-1438.129 -964.768)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(200.15 222.298)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "l",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.51 16.109)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M840.817,427.878H743.9a3.2,3.2,0,0,0-3.124,3.192v78.647H854.72V442Z",
    transform: "translate(-740.78 -427.878)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M1627.065,442.75l-12.717.11a1.126,1.126,0,0,1-.84-.366,1.181,1.181,0,0,1-.263-.9V428.724Z",
    transform: "translate(-1513.18 -428.627)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.812 14.543)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1068.439,577.128a22.417,22.417,0,0,1-1.417,8.115,13.442,13.442,0,0,1-4,5.775,9.265,9.265,0,0,1-6.006,2.094,7.472,7.472,0,0,1-4.035-1.093,6.273,6.273,0,0,1-2.526-2.88h-.493a10.563,10.563,0,0,1-8.47,3.973,11.335,11.335,0,0,1-8.593-3.28q-3.142-3.28-3.142-8.978a13.871,13.871,0,0,1,4.127-10.472,14.893,14.893,0,0,1,10.78-3.973,37.318,37.318,0,0,1,5.836.508,32.107,32.107,0,0,1,5.251,1.217l-.708,15.06q0,4.281,2.341,4.281,1.971,0,3.142-2.88a20.3,20.3,0,0,0,1.17-7.53,18.085,18.085,0,0,0-2.063-8.762,14,14,0,0,0-5.806-5.806,17.837,17.837,0,0,0-8.547-2,21.864,21.864,0,0,0-10.81,2.556,17.089,17.089,0,0,0-7.037,7.376,24.258,24.258,0,0,0-2.448,11.134q0,8.5,4.543,13.043t13.166,4.543a39.679,39.679,0,0,0,7.176-.724,47.569,47.569,0,0,0,7.7-2.11v5.913a37.018,37.018,0,0,1-14.629,2.8q-11.7,0-18.248-6.16t-6.545-17.124a28.664,28.664,0,0,1,3.342-13.813A24.246,24.246,0,0,1,1031,558.2a28.154,28.154,0,0,1,14.214-3.526,25.838,25.838,0,0,1,12.1,2.772,19.656,19.656,0,0,1,8.223,7.884A23.524,23.524,0,0,1,1068.439,577.128Zm-31.538,3.85q0,6.5,5.3,6.5a4.923,4.923,0,0,0,4.219-1.956q1.447-1.956,1.755-6.36l.4-6.806a16.858,16.858,0,0,0-3.542-.339,7.607,7.607,0,0,0-5.99,2.4A9.507,9.507,0,0,0,1036.9,580.978Z",
    transform: "translate(-1018.145 -554.676)"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(176.392 246.77)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M2083.831,768.982l.06.725v0a.126.126,0,1,0,.25-.021h0l-.068-.731a.122.122,0,0,0-.243.021Z",
    transform: "translate(-1899.526 -738.103)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M2084.891,790.089l0,.727v0a.138.138,0,1,0,.276,0h0l0-.734a.135.135,0,0,0-.269,0Z",
    transform: "translate(-1900.461 -756.788)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M2083.665,811.216l-.065.725v0a.151.151,0,1,0,.3.027h0l.059-.733a.147.147,0,0,0-.293-.025Z",
    transform: "translate(-1899.321 -775.492)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M2080.682,832.216l-.125.717v0a.163.163,0,0,0,.322.056v0l.118-.726a.159.159,0,0,0-.314-.053Z",
    transform: "translate(-1896.625 -794.084)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M2076.015,852.949l-.181.7v0a.176.176,0,0,0,.34.088v0l.176-.713a.172.172,0,0,0-.334-.084Z",
    transform: "translate(-1892.44 -812.442)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M2069.736,873.284l-.235.688v0a.188.188,0,1,0,.356.122v0l.231-.7a.185.185,0,0,0-.35-.118Z",
    transform: "translate(-1886.829 -830.449)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M2061.916,893.124l-.287.668,0,0a.2.2,0,0,0,.369.159v0l.283-.68a.2.2,0,0,0-.363-.154Z",
    transform: "translate(-1879.854 -848.018)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M2052.632,912.357l-.336.644,0,0a.213.213,0,0,0,.378.2v0l.333-.656a.21.21,0,0,0-.373-.192Z",
    transform: "translate(-1871.585 -865.051)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M2041.948,930.873l-.383.617,0,0a.226.226,0,0,0,.384.238v0l.381-.63a.222.222,0,0,0-.378-.232Z",
    transform: "translate(-1862.076 -881.45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M2029.927,948.578l-.427.587,0,0a.238.238,0,0,0,.385.281v0l.427-.6a.235.235,0,0,0-.38-.274Z",
    transform: "translate(-1851.383 -897.132)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M2016.628,965.37l-.47.553,0,0a.251.251,0,1,0,.382.325l0,0,.471-.566a.247.247,0,0,0-.378-.318Z",
    transform: "translate(-1839.559 -912.006)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M2002.107,981.146l-.511.516,0,0a.263.263,0,1,0,.374.371l0,0,.514-.53a.26.26,0,0,0-.371-.363Z",
    transform: "translate(-1826.652 -925.982)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1986.43,995.8l-.548.474,0,0a.276.276,0,0,0,.361.417l0,0,.553-.488a.272.272,0,0,0-.358-.41Z",
    transform: "translate(-1812.722 -938.965)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1969.671,1009.2l-.584.428-.006,0a.288.288,0,1,0,.341.465l0,0,.59-.442a.285.285,0,0,0-.339-.457Z",
    transform: "translate(-1797.834 -950.84)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1951.928,1021.248l-.616.38-.006,0a.3.3,0,0,0,.312.507h0l.626-.391a.3.3,0,0,0-.311-.5Z",
    transform: "translate(-1782.076 -961.514)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1933.284,1031.843l-.645.326-.007,0a.3.3,0,0,0,.275.544h0l.657-.336a.3.3,0,0,0-.274-.539Z",
    transform: "translate(-1765.521 -970.904)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1913.831,1040.819l-.672.269-.007,0a.312.312,0,0,0,.231.579h0l.685-.278a.309.309,0,0,0-.231-.574Z",
    transform: "translate(-1748.249 -978.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1893.719,1048.128l-.692.213-.007,0a.319.319,0,0,0,.188.609h0l.7-.222a.317.317,0,0,0-.188-.6Z",
    transform: "translate(-1730.401 -985.339)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1873.123,1053.833l-.706.159h-.007a.326.326,0,1,0,.143.635h0l.719-.167a.323.323,0,0,0-.144-.631Z",
    transform: "translate(-1712.129 -990.396)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1852.185,1057.954l-.716.106h-.007a.333.333,0,0,0,.1.658h0l.73-.112a.33.33,0,0,0-.1-.654Z",
    transform: "translate(-1693.556 -994.049)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1831.027,1060.534l-.722.054h-.007a.34.34,0,0,0,.052.677h0l.736-.06a.338.338,0,0,0-.053-.673Z",
    transform: "translate(-1674.794 -996.335)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1809.765,1061.632l-.724.006h-.007a.347.347,0,0,0,.005.694h0l.738-.01a.345.345,0,0,0-.007-.689Z",
    transform: "translate(-1655.942 -997.309)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1788.495,1061l-.723-.041h-.007a.354.354,0,1,0-.04.707h0l.737.037a.352.352,0,0,0,.038-.7Z",
    transform: "translate(-1637.086 -996.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1767.3,1059l-.72-.085h-.006a.361.361,0,1,0-.084.717h0l.733.082a.359.359,0,0,0,.082-.713Z",
    transform: "translate(-1618.302 -994.903)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1746.26,1055.766l-.714-.126h-.006a.368.368,0,1,0-.128.724h0l.727.124a.366.366,0,0,0,.125-.721Z",
    transform: "translate(-1599.652 -991.998)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1725.433,1051.363l-.705-.165h-.006a.375.375,0,1,0-.171.73h0l.718.164a.373.373,0,0,0,.168-.727Z",
    transform: "translate(-1581.196 -988.061)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1704.854,1045.854l-.7-.2-.006,0a.382.382,0,0,0-.213.734h0l.71.2a.38.38,0,0,0,.209-.73Z",
    transform: "translate(-1562.96 -983.146)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1684.585,1039.3l-.686-.237-.005,0a.389.389,0,1,0-.254.735h0l.7.237a.387.387,0,0,0,.251-.732Z",
    transform: "translate(-1545.002 -977.311)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1664.663,1031.763l-.673-.27-.005,0a.4.4,0,0,0-.295.735h0l.686.27a.394.394,0,0,0,.291-.732Z",
    transform: "translate(-1527.351 -970.599)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1645.123,1023.277l-.66-.3-.005,0a.4.4,0,0,0-.335.733h0l.672.3a.4.4,0,0,0,.332-.73Z",
    transform: "translate(-1510.041 -963.051)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1625.995,1013.877l-.646-.333-.005,0a.41.41,0,0,0-.376.729h0l.658.334a.408.408,0,0,0,.372-.726Z",
    transform: "translate(-1493.094 -954.693)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1607.368,1003.656l-.63-.36,0,0a.413.413,0,1,0-.409.717h0l.639.363a.412.412,0,0,0,.407-.717Z",
    transform: "translate(-1476.601 -945.613)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1589.16,992.685l-.617-.384,0,0a.415.415,0,0,0-.439.7h0l.625.388a.415.415,0,1,0,.437-.7Z",
    transform: "translate(-1460.478 -935.871)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1571.372,981.042l-.6-.407,0,0a.418.418,0,0,0-.467.692h0l.61.411a.417.417,0,1,0,.465-.692Z",
    transform: "translate(-1444.729 -925.537)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1554,968.789l-.588-.427,0,0a.42.42,0,1,0-.493.68h0l.6.431a.419.419,0,1,0,.491-.68Z",
    transform: "translate(-1429.347 -914.663)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1537.024,955.983l-.575-.445,0,0a.422.422,0,0,0-.517.668h0l.582.449a.421.421,0,1,0,.515-.668Z",
    transform: "translate(-1414.319 -903.302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1520.432,942.685l-.563-.462,0,0a.425.425,0,1,0-.538.656h0l.569.465a.424.424,0,1,0,.536-.657Z",
    transform: "translate(-1399.63 -891.508)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1504.2,928.95l-.551-.476,0,0a.427.427,0,0,0-.558.646h0l.557.479a.426.426,0,1,0,.556-.646Z",
    transform: "translate(-1385.257 -879.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1488.294,914.832l-.54-.489,0,0a.429.429,0,1,0-.576.637h0l.545.492a.429.429,0,0,0,.574-.637Z",
    transform: "translate(-1371.178 -866.813)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1472.7,900.383l-.53-.5,0,0a.432.432,0,0,0-.592.628h0l.535.5a.431.431,0,0,0,.59-.629Z",
    transform: "translate(-1357.368 -854.007)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1457.366,885.649l-.522-.509v0a.434.434,0,0,0-.606.621h0l.526.511a.433.433,0,1,0,.6-.621Z",
    transform: "translate(-1343.796 -840.948)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1442.258,870.66l-.515-.517h0a.436.436,0,0,0-.618.615h0l.519.519a.435.435,0,1,0,.616-.616Z",
    transform: "translate(-1330.42 -827.666)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1427.353,855.473l-.509-.524h0a.439.439,0,0,0-.629.611h0l.512.525a.438.438,0,0,0,.627-.611Z",
    transform: "translate(-1317.223 -814.211)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1412.612,840.125l-.5-.529a.441.441,0,1,0-.64.606h0l.507.53a.44.44,0,1,0,.636-.608Z",
    transform: "translate(-1304.17 -800.616)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1398,824.656l-.5-.533a.443.443,0,1,0-.648.605h0l.5.534a.443.443,0,1,0,.644-.607Z",
    transform: "translate(-1291.231 -786.915)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1383.473,809.1l-.5-.535a.446.446,0,0,0-.653.606h0l.5.535a.445.445,0,0,0,.651-.607Z",
    transform: "translate(-1278.37 -773.142)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1368.99,793.5l-.5-.537a.448.448,0,1,0-.657.609h0l.5.536a.447.447,0,0,0,.656-.608Z",
    transform: "translate(-1265.544 -759.324)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1354.515,777.9l-.5-.536a.45.45,0,0,0-.66.612h0l.5.535a.449.449,0,0,0,.659-.612Z",
    transform: "translate(-1252.726 -745.515)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1340,762.335l-.5-.535a.452.452,0,0,0-.662.617h0l.5.533a.452.452,0,0,0,.66-.617Z",
    transform: "translate(-1239.872 -731.738)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1325.409,746.844l-.5-.532a.455.455,0,1,0-.661.625h0l.5.53a.454.454,0,1,0,.66-.624Z",
    transform: "translate(-1226.949 -718.027)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1310.7,731.462l-.508-.528a.457.457,0,1,0-.659.634h0l.507.525h0a.456.456,0,0,0,.657-.633Z",
    transform: "translate(-1213.921 -704.415)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1295.833,716.23l-.514-.523a.459.459,0,0,0-.655.644h0l.513.519h0a.459.459,0,0,0,.654-.644Z",
    transform: "translate(-1200.754 -690.937)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1280.773,701.189l-.521-.516a.462.462,0,1,0-.65.656h0l.519.512h0a.461.461,0,0,0,.648-.656Z",
    transform: "translate(-1187.414 -677.631)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1265.481,686.38l-.53-.507a.464.464,0,1,0-.642.67h0l0,0,.527.5,0,0a.464.464,0,0,0,.641-.67Z",
    transform: "translate(-1173.87 -664.532)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1249.95,671.879l-.542-.5a.463.463,0,0,0-.626.682l0,0,.536.494,0,0a.463.463,0,1,0,.628-.682Z",
    transform: "translate(-1160.119 -651.709)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1234.12,657.706l-.552-.485a.461.461,0,1,0-.609.693l0,0,.546.482,0,0a.461.461,0,1,0,.61-.692Z",
    transform: "translate(-1146.104 -639.179)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1217.965,643.912l-.563-.471a.459.459,0,0,0-.589.7l0,0,.557.467,0,0a.46.46,0,1,0,.591-.7Z",
    transform: "translate(-1131.802 -626.987)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1201.463,630.555l-.576-.456a.457.457,0,1,0-.568.717l0,0,.569.452,0,0a.458.458,0,0,0,.569-.718Z",
    transform: "translate(-1117.193 -615.182)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1184.574,617.674l-.59-.438a.455.455,0,1,0-.544.731l0,0,.582.434,0,0a.456.456,0,0,0,.545-.731Z",
    transform: "translate(-1102.241 -603.801)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1167.285,605.33l-.6-.419a.454.454,0,1,0-.518.745l0,0,.6.415,0,0a.454.454,0,1,0,.519-.746Z",
    transform: "translate(-1086.935 -592.898)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1149.578,593.577l-.62-.4a.452.452,0,1,0-.489.76l0,0,.61.394,0,0a.453.453,0,0,0,.491-.76Z",
    transform: "translate(-1071.259 -582.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1131.45,582.483l-.634-.375a.45.45,0,0,0-.459.775l0,0,.625.371,0,0a.451.451,0,0,0,.46-.775Z",
    transform: "translate(-1055.213 -572.727)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1112.929,572.069l-.647-.351a.448.448,0,0,0-.428.788l0,0,.638.348,0,0a.449.449,0,1,0,.43-.788Z",
    transform: "translate(-1038.82 -563.535)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1094.042,562.339l-.659-.328a.447.447,0,1,0-.4.8l0,0,.65.324,0,0a.447.447,0,0,0,.4-.8Z",
    transform: "translate(-1022.103 -554.949)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1074.816,553.3l-.67-.3a.445.445,0,0,0-.367.81l0,0,.661.3,0,0a.445.445,0,0,0,.369-.811Z",
    transform: "translate(-1005.087 -546.975)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1055.275,544.958l-.681-.279a.443.443,0,1,0-.336.82l0,0,.672.277,0,0a.444.444,0,1,0,.338-.82Z",
    transform: "translate(-987.793 -539.617)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1035.448,537.319l-.69-.255a.441.441,0,0,0-.306.828h0l.681.253,0,0a.442.442,0,1,0,.307-.828Z",
    transform: "translate(-970.247 -532.88)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1015.36,530.386l-.7-.231a.44.44,0,0,0-.275.835h0l.69.229,0,0a.44.44,0,0,0,.277-.836Z",
    transform: "translate(-952.47 -526.769)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M995.036,524.167l-.707-.206a.438.438,0,0,0-.245.841h0l.7.2h0a.438.438,0,1,0,.246-.841Z",
    transform: "translate(-934.486 -521.289)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M974.5,518.668l-.714-.181a.436.436,0,1,0-.214.845h0l.7.179h0a.437.437,0,1,0,.216-.846Z",
    transform: "translate(-916.317 -516.447)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M953.79,513.893l-.72-.156a.434.434,0,1,0-.183.849h0l.71.155h0a.435.435,0,0,0,.185-.85Z",
    transform: "translate(-897.989 -512.245)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M932.921,509.85l-.724-.13a.432.432,0,0,0-.153.851h0l.715.129h0a.433.433,0,0,0,.154-.852Z",
    transform: "translate(-879.525 -508.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M911.923,506.544l-.729-.1a.431.431,0,1,0-.122.853h0l.719.1h0a.431.431,0,0,0,.124-.854Z",
    transform: "translate(-860.946 -505.788)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M890.823,503.979l-.732-.079a.429.429,0,0,0-.092.853h0l.723.079h0a.429.429,0,0,0,.093-.854Z",
    transform: "translate(-842.278 -503.542)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M869.645,502.163l-.734-.053a.427.427,0,1,0-.061.852h0l.725.053h0a.428.428,0,1,0,.063-.853Z",
    transform: "translate(-823.543 -501.959)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M848.417,501.1l-.735-.027a.425.425,0,1,0-.031.85h0l.726.027h0a.426.426,0,1,0,.032-.851Z",
    transform: "translate(-804.763 -501.042)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M827.167,500.8h-.736a.424.424,0,1,0,0,.847h0l.727,0h0a.424.424,0,0,0,0-.848Z",
    transform: "translate(-785.965 -500.797)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M805.921,501.057l-.735.026a.422.422,0,0,0,.03.843h0l.726-.025h0a.422.422,0,0,0-.029-.844Z",
    transform: "translate(-767.171 -501.027)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M784.7,502.085l-.734.053a.42.42,0,1,0,.06.838h0l.725-.051h0a.421.421,0,0,0-.059-.839Z",
    transform: "translate(-748.404 -501.936)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M763.547,503.887l-.732.08a.418.418,0,0,0,.091.832h0l.722-.078h0a.419.419,0,0,0-.09-.833Z",
    transform: "translate(-729.691 -503.531)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M742.476,506.47l-.728.107a.417.417,0,0,0,.121.824h0l.719-.1h0a.417.417,0,0,0-.12-.825Z",
    transform: "translate(-711.054 -505.816)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M721.527,509.856l-.724.137a.415.415,0,0,0,.154.815h0l.714-.134h.005a.415.415,0,0,0-.153-.816Z",
    transform: "translate(-692.528 -508.81)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M700.75,514.119l-.717.168a.413.413,0,1,0,.189.8h0l.707-.165h.005a.413.413,0,1,0-.188-.805Z",
    transform: "translate(-674.156 -512.582)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M680.2,519.311l-.709.2a.411.411,0,1,0,.225.791h.005l.7-.2.006,0a.412.412,0,1,0-.224-.792Z",
    transform: "translate(-655.987 -517.173)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M659.964,525.5l-.7.238a.406.406,0,1,0,.263.769h0l.687-.231.006,0a.408.408,0,0,0-.26-.773Z",
    transform: "translate(-638.104 -522.648)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M640.1,532.754l-.685.276a.4.4,0,0,0,.3.744l0,0,.673-.268.006,0a.4.4,0,0,0-.3-.748Z",
    transform: "translate(-620.55 -529.063)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M620.7,541.12l-.667.317a.4.4,0,0,0,.339.715l.005,0,.655-.307.007,0a.4.4,0,0,0-.337-.719Z",
    transform: "translate(-603.41 -536.461)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M601.869,550.666l-.646.359a.39.39,0,1,0,.379.682l.005,0,.634-.349.007,0a.392.392,0,0,0-.378-.686Z",
    transform: "translate(-586.784 -544.902)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M583.753,561.458l-.62.4a.385.385,0,1,0,.42.644l.006,0,.607-.392.007,0a.386.386,0,0,0-.419-.649Z",
    transform: "translate(-570.792 -554.445)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M566.505,573.55l-.587.45a.379.379,0,1,0,.461.6l.006,0,.575-.437.007-.005a.381.381,0,1,0-.461-.607Z",
    transform: "translate(-555.574 -565.136)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M550.3,586.973l-.549.5a.374.374,0,1,0,.5.554l.006-.005.537-.482.007-.006a.376.376,0,1,0-.5-.559Z",
    transform: "translate(-541.283 -577.003)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M535.316,601.73l-.5.543a.369.369,0,1,0,.54.5l.006-.006.493-.526.007-.007a.37.37,0,1,0-.54-.506Z",
    transform: "translate(-528.08 -590.049)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M521.747,617.78l-.452.589a.363.363,0,0,0,.576.442l.006-.008.441-.569.007-.009a.365.365,0,1,0-.577-.447Z",
    transform: "translate(-516.134 -604.236)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M509.879,635.137l-.389.63a.358.358,0,1,0,.609.376l0-.008.381-.611.006-.009a.359.359,0,0,0-.61-.381Z",
    transform: "translate(-505.701 -619.578)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M499.815,653.631l-.326.666a.352.352,0,0,0,.633.31l0-.008.32-.646,0-.009a.354.354,0,0,0-.634-.314Z",
    transform: "translate(-496.863 -635.926)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M491.582,673.064l-.262.693a.347.347,0,1,0,.649.245l0-.007.258-.674,0-.009a.349.349,0,1,0-.651-.25Z",
    transform: "translate(-489.644 -653.107)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M485.188,693.227l-.2.712a.342.342,0,0,0,.658.183l0-.007.2-.694,0-.009a.343.343,0,1,0-.661-.187Z",
    transform: "translate(-484.049 -670.934)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M480.616,713.918l-.135.728a.336.336,0,0,0,.661.122v-.007l.135-.71,0-.009a.338.338,0,0,0-.664-.126Z",
    transform: "translate(-480.063 -689.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M477.855,734.984l-.072.736a.331.331,0,1,0,.659.064v-.007l.074-.719v-.008a.333.333,0,1,0-.662-.068Z",
    transform: "translate(-477.678 -707.859)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M476.888,756.251l-.01.739a.326.326,0,1,0,.651.009v-.007l.013-.723v-.008a.327.327,0,0,0-.654-.012Z",
    transform: "translate(-476.878 -726.667)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M477.3,777.567l.052.738a.32.32,0,1,0,.639-.045v-.007l-.048-.721v-.008a.322.322,0,0,0-.642.042Z",
    transform: "translate(-477.254 -745.519)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M479.423,798.782l.114.731a.315.315,0,0,0,.622-.1v-.007l-.108-.715v-.008a.316.316,0,1,0-.626.095Z",
    transform: "translate(-479.128 -764.282)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M483.324,819.745l.176.718a.309.309,0,1,0,.6-.147l0-.006-.169-.7,0-.008a.311.311,0,1,0-.6.145Z",
    transform: "translate(-482.577 -782.824)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M489.01,840.3l.238.7a.3.3,0,0,0,.576-.2l0-.007-.23-.686,0-.008a.306.306,0,0,0-.58.194Z",
    transform: "translate(-487.604 -801.004)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M496.484,860.271l.3.675a.3.3,0,0,0,.546-.242l0-.006-.29-.661,0-.008a.3.3,0,0,0-.55.241Z",
    transform: "translate(-494.212 -818.668)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M505.743,879.477l.362.645a.293.293,0,1,0,.511-.287l0-.006-.351-.632,0-.007a.295.295,0,1,0-.516.286Z",
    transform: "translate(-502.399 -835.657)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M516.8,897.749l.424.606a.284.284,0,0,0,.467-.323l0-.007-.41-.6,0-.007a.287.287,0,0,0-.472.325Z",
    transform: "translate(-512.179 -851.822)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M529.617,914.863l.482.56a.274.274,0,0,0,.417-.356l-.006-.007-.467-.551-.005-.007a.277.277,0,0,0-.423.359Z",
    transform: "translate(-523.508 -866.968)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M544.091,930.59l.538.508a.265.265,0,0,0,.365-.383l-.006-.006-.523-.5-.006-.006a.268.268,0,0,0-.37.386Z",
    transform: "translate(-536.308 -880.887)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M560.1,944.778l.585.451a.255.255,0,0,0,.313-.4l-.006,0-.57-.446-.006,0a.258.258,0,0,0-.318.406Z",
    transform: "translate(-550.463 -893.448)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M577.411,957.317l.625.392a.246.246,0,0,0,.263-.415l-.006,0-.611-.389-.006,0a.248.248,0,0,0-.267.419Z",
    transform: "translate(-565.777 -904.551)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M595.832,968.157l.659.332a.236.236,0,0,0,.214-.421l-.006,0-.645-.331-.006,0a.239.239,0,0,0-.218.425Z",
    transform: "translate(-582.072 -914.154)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M615.16,977.269l.685.271a.226.226,0,0,0,.169-.42l-.006,0-.672-.272-.006,0a.229.229,0,1,0-.172.425Z",
    transform: "translate(-599.172 -922.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M635.2,984.636l.707.211a.217.217,0,0,0,.126-.415l-.005,0-.694-.213-.005,0a.22.22,0,1,0-.129.42Z",
    transform: "translate(-616.906 -928.763)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M655.815,990.258l.721.15a.207.207,0,0,0,.086-.406h-.005l-.71-.153H655.9a.21.21,0,1,0-.089.411Z",
    transform: "translate(-635.144 -933.753)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M676.816,994.122l.731.089a.2.2,0,0,0,.049-.392h-.005l-.72-.093h0a.2.2,0,1,0-.052.4Z",
    transform: "translate(-653.728 -937.188)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M698.059,996.218l.735.027a.188.188,0,0,0,.016-.376h0l-.726-.033h0a.191.191,0,0,0-.017.382Z",
    transform: "translate(-672.529 -939.059)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M719.4,996.309l.735-.035a.179.179,0,0,0-.015-.357h0l-.726.029h0a.181.181,0,1,0,.014.363Z",
    transform: "translate(-691.414 -939.131)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M740.678,994.33l.73-.1a.169.169,0,0,0-.044-.335h0l-.722.091h0a.172.172,0,1,0,.043.341Z",
    transform: "translate(-710.25 -937.341)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M761.762,990.51l.718-.162a.159.159,0,0,0-.069-.311h0l-.71.154h0a.162.162,0,1,0,.069.317Z",
    transform: "translate(-728.912 -933.922)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M782.437,984.829l.7-.226a.15.15,0,0,0-.091-.286h0l-.692.218h0a.153.153,0,1,0,.092.291Z",
    transform: "translate(-747.215 -928.855)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M802.531,977.262l.675-.292a.14.14,0,0,0-.11-.258l0,0-.67.283,0,0a.143.143,0,0,0,.112.264Z",
    transform: "translate(-765.004 -922.119)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M821.855,967.81l.643-.357a.131.131,0,0,0-.126-.229l0,0-.639.348,0,0a.134.134,0,0,0,.128.235Z",
    transform: "translate(-782.113 -913.715)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M840.188,957.205l.473-.327a.122.122,0,0,0-.138-.2l0,0-.471.32,0,0a.124.124,0,1,0,.139.205Z",
    transform: "translate(-798.347 -904.373)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(162.151 214.909)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.83 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M454.853,259.641a.748.748,0,0,1-.705-.5l-1.044-2.949a15.174,15.174,0,0,1-4.093-1.658l-2.8,1.394a.747.747,0,0,1-.857-.137l-2.9-2.848a.749.749,0,0,1-.151-.855l1.348-2.825a15.2,15.2,0,0,1-1.725-4.066l-2.965-1a.747.747,0,0,1-.51-.7l-.033-4.062a.748.748,0,0,1,.5-.711l2.949-1.044a15.2,15.2,0,0,1,1.658-4.093l-1.394-2.8a.747.747,0,0,1,.137-.857l2.848-2.9a.747.747,0,0,1,.855-.15l2.825,1.348a15.179,15.179,0,0,1,4.066-1.725l1-2.966a.748.748,0,0,1,.7-.509L458.62,223h.006a.748.748,0,0,1,.7.5l1.044,2.948a15.191,15.191,0,0,1,4.093,1.658l2.8-1.394a.75.75,0,0,1,.857.136l2.9,2.849a.747.747,0,0,1,.15.854l-1.348,2.825a15.188,15.188,0,0,1,1.725,4.066l2.965,1a.748.748,0,0,1,.509.7l.033,4.062a.748.748,0,0,1-.5.711l-2.948,1.043a15.186,15.186,0,0,1-1.658,4.094l1.394,2.8a.748.748,0,0,1-.136.857l-2.849,2.9a.747.747,0,0,1-.854.15l-2.825-1.348a15.192,15.192,0,0,1-4.066,1.725l-1,2.965a.749.749,0,0,1-.7.51l-4.062.033Zm-5.8-6.174.221.135a14.254,14.254,0,0,0,4.289,1.737l.253.057,1.17,3.306,3.79-.031,1.116-3.325.252-.061a14.265,14.265,0,0,0,4.26-1.807l.219-.138,3.167,1.511,2.657-2.7-1.563-3.142.135-.221a14.254,14.254,0,0,0,1.737-4.289l.057-.253,3.306-1.17-.031-3.79-3.325-1.116-.061-.252a14.264,14.264,0,0,0-1.807-4.26l-.138-.219,1.511-3.167-2.7-2.658-3.142,1.563-.221-.135a14.26,14.26,0,0,0-4.289-1.737l-.253-.057-1.17-3.306-3.79.031-1.116,3.325-.252.061a14.255,14.255,0,0,0-4.26,1.807l-.219.138-3.167-1.511-2.658,2.7,1.563,3.142-.135.221a14.269,14.269,0,0,0-1.737,4.289l-.057.252-3.306,1.171.031,3.789,3.325,1.116.061.252a14.261,14.261,0,0,0,1.807,4.26l.138.219-1.511,3.167,2.7,2.657Zm4.17-26.564h0Zm3.458,24.756a10.27,10.27,0,0,1-.082-20.54,10.362,10.362,0,0,1,2.176.213.469.469,0,0,1-.19.919,9.334,9.334,0,1,0,7.43,9.062,9.318,9.318,0,0,0-1.362-4.78.469.469,0,1,1,.8-.489,10.272,10.272,0,0,1-8.687,15.616Z",
    transform: "translate(-438.42 -223.002)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M566.666,355.344a4.077,4.077,0,0,1-1.023-8.021h0a4.076,4.076,0,1,1,1.023,8.021Zm-.786-7.113a3.137,3.137,0,1,0,3.829,2.243,3.116,3.116,0,0,0-3.829-2.243Z",
    transform: "translate(-548.353 -332.947)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 34.22)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M363.134,539.038a.486.486,0,0,1-.391-.2l-.852-1.156a7.4,7.4,0,0,1-2.017-.182l-1.046.986a.485.485,0,0,1-.559.077l-1.73-.906a.486.486,0,0,1-.255-.5l.215-1.422a7.421,7.421,0,0,1-1.3-1.554l-1.436-.042a.487.487,0,0,1-.449-.34l-.583-1.865a.486.486,0,0,1,.176-.536l1.156-.852a7.424,7.424,0,0,1,.182-2.017l-.987-1.046a.486.486,0,0,1-.077-.558l.907-1.731a.486.486,0,0,1,.5-.255l1.42.215a7.436,7.436,0,0,1,1.554-1.3l.042-1.436a.486.486,0,0,1,.34-.45l1.865-.583a.486.486,0,0,1,.536.175l.852,1.157a7.452,7.452,0,0,1,2.017.182l1.046-.986a.487.487,0,0,1,.558-.078l1.731.907a.486.486,0,0,1,.255.5l-.215,1.421a7.429,7.429,0,0,1,1.3,1.554l1.436.042a.485.485,0,0,1,.449.341l.583,1.864a.486.486,0,0,1-.176.536l-1.156.852a7.421,7.421,0,0,1-.182,2.017l.986,1.046a.486.486,0,0,1,.077.558L369,535.21a.485.485,0,0,1-.5.255l-1.422-.215a7.442,7.442,0,0,1-1.554,1.3l-.042,1.436a.486.486,0,0,1-.34.449l-1.865.583A.478.478,0,0,1,363.134,539.038Zm-.065-.694h0Zm-.84-1.388.989,1.342,1.568-.49.049-1.666.167-.1a6.738,6.738,0,0,0,1.677-1.4l.127-.147,1.649.25.762-1.455-1.144-1.213.049-.188a6.73,6.73,0,0,0,.2-2.176l-.014-.194,1.342-.988-.49-1.568-1.666-.049-.1-.167a6.725,6.725,0,0,0-1.4-1.677l-.147-.127.25-1.648-1.455-.762-1.213,1.144-.188-.049a6.728,6.728,0,0,0-2.176-.2l-.194.014-.988-1.341-1.568.49-.049,1.666-.167.1a6.731,6.731,0,0,0-1.676,1.4l-.127.147-1.649-.25-.762,1.455,1.144,1.213-.048.188a6.729,6.729,0,0,0-.2,2.175l.014.194-1.342.988.49,1.568,1.666.048.1.167a6.735,6.735,0,0,0,1.4,1.677l.147.127-.25,1.649,1.455.762,1.213-1.144.188.048a6.74,6.74,0,0,0,2.176.2Zm-3.633.985h0Zm-1.731-.906h0Zm12.457-3.631h0Zm-.215-6.588h0Zm-14.619-1.181h0Zm11.741-2.266h0Zm-7.915-.928h0Zm-.352-.01h0Zm2.064-.371h0Zm1.508,13.247a5.067,5.067,0,0,1-.457-10.113.352.352,0,0,1,.064.7,4.363,4.363,0,1,0,4.554,3.044,4.356,4.356,0,0,0-1.258-1.953.352.352,0,1,1,.468-.526,5.067,5.067,0,0,1-3.37,8.847Z",
    transform: "translate(-352.711 -521.365)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(342.117 293.434)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M1941.049,1009.045a14.243,14.243,0,0,0-3.6,7.127c-.894,4.561-3.018-6.448-3.018-6.448h-2.146s-.81,11.343,5.25,12.245a3.254,3.254,0,0,0,3.037-1.2,15.881,15.881,0,0,0,3.25-6.288A7.648,7.648,0,0,0,1941.049,1009.045Z",
    transform: "translate(-1931.055 -997.418)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M2094.428,1442.73a.381.381,0,0,0-.01-.1,5.312,5.312,0,0,0-2.583-3.044l-1,.078c-.574,1.774-.944,2.64-.852,3.124,0,.014.007.026.01.04A23.668,23.668,0,0,0,2094.428,1442.73Z",
    transform: "translate(-2070.687 -1378.578)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M2090.183,1467.107a.433.433,0,0,0,.317.32,13.692,13.692,0,0,0,3.815-.054.363.363,0,0,0,.3-.362A23.679,23.679,0,0,1,2090.183,1467.107Z",
    transform: "translate(-2070.875 -1402.859)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M2099.83,1426.04l-.437,2.1a.344.344,0,0,1-.294.283,2.915,2.915,0,0,1-.677-.011.432.432,0,0,1-.342-.508l.3-1.868Z",
    transform: "translate(-2077.86 -1366.587)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M1982.281,1465.6a5.764,5.764,0,0,0,1.9-.272c0,.106,0,.214,0,.326a.211.211,0,0,1-.2.214l-5.854-.038a.267.267,0,0,1-.215-.389C1978.678,1465.5,1980.633,1465.646,1982.281,1465.6Z",
    transform: "translate(-1971.455 -1401.369)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M1978.119,1444.17a.277.277,0,0,1,.023-.044,7.459,7.459,0,0,1,4.436-2.785l1.248-.04a5.989,5.989,0,0,1,.566,2.756,5.768,5.768,0,0,1-1.9.272C1980.842,1444.376,1978.887,1444.234,1978.119,1444.17Z",
    transform: "translate(-1971.664 -1380.098)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M2017.411,1422.473c-.014.093-.185,1.507-.251,2.055a.272.272,0,0,1-.229.245,2.856,2.856,0,0,1-.857-.013.369.369,0,0,1-.28-.37v-2.22Z",
    transform: "translate(-2005.018 -1363.161)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M2023.892,1185.131s2,17.754.888,28.851a8.582,8.582,0,0,1-2-.222s-2.076-17.359-2.747-22.327a.167.167,0,0,0-.329-.01c-.828,4.179-4.082,20.568-4.469,22.115a2.767,2.767,0,0,1-2,0s1.775-23.747,3.107-27.963Z",
    transform: "translate(-2002.756 -1153.308)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M2024.46,1001.474s-8.433-1.331-15.091.444l.444,6.88s1.776,9.543,3.107,13.76c0,0,5.1.888,7.546-.444,0,0,2-11.984,3.107-13.76C2023.573,1008.354,2024.682,1003.694,2024.46,1001.474Z",
    transform: "translate(-1999.33 -990.291)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M2065.49,942.024l.9,6.86s-2.347,1.078-3.991-.046l.354-4.01Z",
    transform: "translate(-2046.278 -938.083)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M2122.962,1005.174s13.094,14.2-2.33,19.641v-1.11s5.77-4.882,1.332-11.54C2121.964,1012.165,2122.519,1005.84,2122.962,1005.174Z",
    transform: "translate(-2097.832 -993.991)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M2090.542,1160.165s-2-1.332-2.885-.888a1.373,1.373,0,0,0-.888,1.11s.444.888,1.11.666,2.219.222,2.885,0C2090.764,1161.052,2090.986,1160.165,2090.542,1160.165Z",
    transform: "translate(-2067.853 -1130.339)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.561 5.119)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M1927.263,952.314l2.818.949a.934.934,0,0,1,.6.885l-.146,4.7c.046.736-.561,1.384-1.135,1.212l-2.259-.77a.579.579,0,0,1-.368-.582l-.05-5.854C1926.723,952.518,1927,952.236,1927.263,952.314Z",
    transform: "translate(-1926.726 -952.301)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M1922.4,971s-.882-2.825-.434-3.3,1.341-1.789,1.4-.715S1923.965,972.689,1922.4,971Z",
    transform: "translate(-1921.838 -959.814)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.717 0.227)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M2044.33,926.2c-.013.082.989,5.447.989,5.447l3.052-.637-.194-5.227S2044.55,924.832,2044.33,926.2Z",
    transform: "translate(-2042.998 -923.645)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M2036.984,912.626a.448.448,0,0,1,.213.332l.313,2.7a.425.425,0,0,1,0,.122c-.037.225-.214.93-.938.712a3.947,3.947,0,0,0-1.606-.274.447.447,0,0,0-.358.526,16.718,16.718,0,0,0,.626,2.386.446.446,0,0,0,.539.275,12.421,12.421,0,0,0,2.61-1.017.448.448,0,0,0,.226-.4c-.018-.727-.061-2.766.015-3.343.071-.536.72-.854,1.028-.975a.45.45,0,0,0,.255-.255.987.987,0,0,0-.621-1.417.448.448,0,0,1-.261-.567.991.991,0,0,0-.556-1.346,1.4,1.4,0,0,0-1.65.335.465.465,0,0,1-.552.082.3.3,0,0,0-.294,0,.434.434,0,0,1-.59-.19,1.147,1.147,0,0,0-1.309-.651c-1.366.21-1.546,1.717-1.2,2.608s1.813.578,2.554.145A1.619,1.619,0,0,1,2036.984,912.626Z",
    transform: "translate(-2032.719 -909.641)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M2082.853,945.554s-.387-1.486.2-1.86,1.431-.161,1.224.972C2084.015,946.075,2082.853,945.554,2082.853,945.554Z",
    transform: "translate(-2076.991 -939.638)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2030.52,909.62a.047.047,0,0,1-.043-.027c-.5-1.062.661-1.91.673-1.919a.048.048,0,1,1,.055.077c-.011.008-1.105.811-.642,1.8a.047.047,0,0,1-.023.063A.047.047,0,0,1,2030.52,909.62Z",
    transform: "translate(-2017.907 -907.665)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(154.883 291.915)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M412.436,1429.837s-.226,1.281-.337,2.55a.874.874,0,0,0,.836.947c1.689.07,5.3.207,6.6.149a.284.284,0,0,0,.25-.39h0a.635.635,0,0,0-.326-.343l-5.968-2.743Z",
    transform: "translate(-398.017 -1368.428)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M413.449,1421.447l.182,1.533a1.9,1.9,0,0,0,1.759-.061l-.433-1.708Z",
    transform: "translate(-399.215 -1360.791)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M378.054,1172.039c-.078.4-.422,19.973,1.671,28.744a.3.3,0,0,1-.175.346,5.187,5.187,0,0,1-1.7.346.513.513,0,0,1-.509-.368,100.634,100.634,0,0,1-3.837-21.971c-.418-10.884,0-.37,0-.37l.245-6.728Z",
    transform: "translate(-363.683 -1140.197)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M349.65,1435.666a9.22,9.22,0,0,0-.709,2.366.533.533,0,0,0,.469.638c.558.055,1.416.125,2.1.121a.532.532,0,0,0,.526-.593,4.482,4.482,0,0,0-1.047-2.459Z",
    transform: "translate(-342.096 -1373.589)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M352.448,1417.783l.425,2.318a1.5,1.5,0,0,0,1.251.086l-.2-2.494Z",
    transform: "translate(-345.21 -1357.677)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ai",
    d: "M337.355,1168.92c-1.711,10.327.371,25.523,1.073,28.5a.464.464,0,0,0,.374.352,3.113,3.113,0,0,0,1.338-.053.425.425,0,0,0,.306-.392c.094-2.4-.075-17.167,1.519-23a1.325,1.325,0,0,1,.511-.731l3.095-2.2.237-3.556Z",
    transform: "translate(-331.266 -1136.478)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.451 4.934)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aj",
    d: "M348.411,1000.208a48.213,48.213,0,0,0-10.786,1.346c-1.528,8.919-.267,19.206-.267,19.206,3.97,1.041,8.448-.636,8.448-.636.66-3.728,3.738-14.219,3.738-14.219a16.889,16.889,0,0,0,6.269-1.989,10.993,10.993,0,0,1-2.173-4.545A17.2,17.2,0,0,1,348.411,1000.208Z",
    transform: "translate(-336.869 -992.267)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M493.016,937.823a.981.981,0,0,0-1.141-.321c-.755,3.188-4.711,5.772-8.776,7.036a10.994,10.994,0,0,0,2.173,4.545C492.018,945.29,493.016,937.823,493.016,937.823Z",
    transform: "translate(-466.328 -937.435)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.999)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M560.638,899.893c.053.168-.558.423-.917-.263a6.458,6.458,0,0,1-.016-2,26.206,26.206,0,0,1,3.072-3.211.482.482,0,0,1,.06.67l-.983,1.024a4.759,4.759,0,0,1,.574,1.135,1.377,1.377,0,0,1-.137,1.014c-.173.311-.408.715-.631,1.031A1.36,1.36,0,0,1,560.638,899.893Z",
    transform: "translate(-559.619 -894.416)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "M566.27,914.981l-.9.76-.281.756.8.886a10.314,10.314,0,0,1,.468-1.825C566.56,915.233,566.456,915.076,566.27,914.981Z",
    transform: "translate(-564.465 -912.622)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M302.378,1023.382l-1.967-4.965s-4.79,3.254-5.577,7.381a10.9,10.9,0,0,1,4.034,1.131C299.6,1025.292,302.378,1023.382,302.378,1023.382Z",
    transform: "translate(-294.204 -1004.195)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M379.55,970.381l-1.632,4.718a.17.17,0,0,0,.077.2,3.835,3.835,0,0,0,3.978-.268.8.8,0,0,0,.369-.572l.528-4.084Z",
    transform: "translate(-367.751 -961.668)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.702 1.891)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M390.89,932.284s1.792,3.373,1.562,4.735-2.45,1.265-4.389.158l-1.355-3.642Z",
    transform: "translate(-384.243 -929.832)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M369.124,916.46a.139.139,0,0,0,.061-.2,3.628,3.628,0,0,1-.5-1.058s-.322-.206.82-.48,2.845-.7,3.2-1.669c.349-.948-.568-3.331-2.031-1.432a.139.139,0,0,1-.22,0,1.433,1.433,0,0,0-1.746-.567,1.315,1.315,0,0,0-.9,1.27.138.138,0,0,1-.164.141,1.6,1.6,0,0,0-1.872.873,1.289,1.289,0,0,0,.092,1.548.138.138,0,0,1-.059.23.834.834,0,0,0-.588.952c.049.882,1.034.8,1.315.764a.139.139,0,0,1,.123.044,4.738,4.738,0,0,0,2.5,1.533.14.14,0,0,0,.147-.185l-.508-1.476a.139.139,0,0,1,.075-.173Z",
    transform: "translate(-365.219 -910.903)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M390.444,957.834s-1.276-.875-1.369-.138,1.149,1.068,1.764.793Z",
    transform: "translate(-386.334 -952.068)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M290.006,1081.287s-3.274,7.457,4.729,8.548l1.091-.909a4.765,4.765,0,0,1-1.819-6.547S291.643,1080.378,290.006,1081.287Z",
    transform: "translate(-289.343 -1059.645)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.192 25.555)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.681)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "an",
    d: "M341.086,1117.242l2.818.949a.934.934,0,0,1,.6.885l-.146,4.7c.046.736-.561,1.384-1.135,1.212l-2.259-.77a.58.58,0,0,1-.368-.582l-.05-5.854C340.546,1117.446,340.825,1117.164,341.086,1117.242Z",
    transform: "translate(-340.549 -1117.229)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M335.1,1133.825a3.824,3.824,0,0,1-.467-2.337c.136-1.289-.116-1.871.485-1.821s1.1.151,1.03.785S336.271,1135.118,335.1,1133.825Z",
    transform: "translate(-334.612 -1128.237)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegMail);
export default __webpack_public_path__ + "static/media/reg-mail.d4c0e7860c54bf831e4853903107f8bc.svg";
export { ForwardRef as ReactComponent };